<template>
  <div class="container">
    <Header></Header>
    <!--  -->
    <div class="pay_header flex-box">
      <img src="@/assets/static/images/jj_logo_new.png" class="icon_logo" />
      <div class="line"></div>
      <div class="fs28 name">采购车</div>
    </div>
    <!--  -->
    <div class="pay_wrap">
      <div class="fs18 flex-box mb40">
        <div class="col90">当前位置：</div>
        <router-link class="col04" to="/">首页<span class="plr5"> / </span></router-link>
        <router-link class="col04" to="/cart">采购车<span class="plr5"> / </span></router-link>
        <div class="now_page fwb">结算</div>
      </div>
      <!--  -->
      <div class="flex-box mb25">
        <div class="comfirm fs24">确认订单信息</div>
        <div class="flex-grow-1 col90 fs20">请在30分钟内完成支付，否则订单会被自动取消。</div>
        <!-- <div class="flex-grow-1 col90 fs20">秒杀倒计时05:00:00，请在倒计时内完成支付，否则订单会被自动取消。</div> -->
      </div>
      <!-- 地址 -->
      <div class="address_box">
        <div class="flex-box mb25">
          <div class="col04 fs20 flex-grow-1">收货地址</div>
          <router-link class="col90 fs20" to="">管理地址</router-link>
        </div>
        <div class="address_list flex-box flex-wrap" :class="{ show: isShowAll }">
          <div class="address_item flex-box flex-col-start active">
            <i class="icon_addr"></i>
            <div class="flex-grow-1">
              <div class="zcol27 fs20 fwb mb20">上海市闵行区合川路3136号8幢东侧5楼B区</div>
              <div class="flex-box">
                <div class="fs18 zcol27 mr10">百晓生</div>
                <div class="fs18 zcol27">18100860000</div>
              </div>
            </div>
          </div>
          <div class="address_item flex-box flex-col-start">
            <i class="icon_addr"></i>
            <div class="flex-grow-1">
              <div class="zcol27 fs20 fwb mb20">上海市闵行区合川路3136号8幢东侧5楼B区</div>
              <div class="flex-box">
                <div class="fs18 zcol27 mr10">百晓生</div>
                <div class="fs18 zcol27">18100860000</div>
              </div>
            </div>
          </div>
          <div class="address_item flex-box flex-col-start">
            <i class="icon_addr"></i>
            <div class="flex-grow-1">
              <div class="zcol27 fs20 fwb mb20">上海市闵行区合川路3136号8幢东侧5楼B区</div>
              <div class="flex-box">
                <div class="fs18 zcol27 mr10">百晓生</div>
                <div class="fs18 zcol27">18100860000</div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex-box more zpointer" @click="showAllAddr">
          <div class="col90 fs20">显示全部地址</div>
          <img src="@/assets/static/icon/z_icon_down2.png" class="icon" />
        </div>
      </div>
      <!-- 商品 -->
      <div class="goods_wrap">
        <div class="col04 fs20 mb15">商品信息</div>
        <div class="goods_title flex-box">
          <div class="fs18 gt1">商品</div>
          <div class="fs18 gt2">规格</div>
          <div class="fs18 gt3">单价(元)</div>
          <div class="fs18 gt4">优惠</div>
          <div class="fs18 gt4">拼团数量</div>
          <div class="fs18 gt5">小计(元)</div>
        </div>
        <div class="goods_item flex-box" v-for="(item,index) in 2" :key="index">
          <img src="@/assets/static/images/z_img_product1.png" class="img1" />
          <div class="name fs18">
            <span class="label fs14">平团</span>
            3件装 | MEDIHEAL 美迪惠尔N.M.F针剂水库保
          </div>
          <div class="fs18 spec">3支/盒</div>
          <div class="fs18 danjia">50.00</div>
          <div class="youhui flex-box">
            <div class="fs18 flex-grow-1">促销优惠</div>
            <i class="icon_down"></i>
          </div>
          <div class="fs18 num">× 100</div>
          <div class="fs18 total">16900.00</div>
        </div>
      </div>

      <!-- 支付 -->
      <div class="pay_box">
        <div class="col04 fs20 mb25">商品信息</div>
        <div class="flex-box flex-wrap mb40">
          <div class="pay_item flex-box active">
            <i class="icon_checkon"></i>
            <img src="@/assets/static/icon/z_icon_pay1.png" class="icon_pay1" />
            <div class="col04 fs20">微信支付</div>
          </div>
          <div class="pay_item flex-box">
            <i class="icon_check"></i>
            <img src="@/assets/static/icon/z_icon_pay2.png" class="icon_pay2" />
            <div class="col04 fs20">公对公付款</div>
          </div>
        </div>
        <div class="flex-box mb40">
          <div class="flex-box">
            <i class="icon_check mr25"></i>
            <div class="fs18 col04">已阅读并同意</div>
            <div class="fs18 zbule1 fwb">《****拼团条款》</div>
          </div>
          <div class="flex-grow-1 flex-box flex-end">
            <div class="fs18 col90 mr20">已选2款 共200件</div>
            <div class="fs24 col04 mr5">需付金额：</div>
            <div class="fs20 zprice1 fwb">¥33800.00</div>
          </div>
        </div>
        <div class="btn_sub">提交订单</div>
      </div>

      <!-- 线下指导 -->
      <div class="guidance_box">
        <div class="guidance1">
          <div class="fs20 col04 fwb mb40">打版是否需要线下指导</div>
          <div class="flex-box">
            <div class="flex-box option zpointer">
              <i class="icon_checkon mr20"></i>
              <div class="fs20 col04">不需要</div>
            </div>
            <div class="flex-box option zpointer">
              <i class="icon_check mr20"></i>
              <div class="fs20 col04">需要</div>
            </div>
          </div>
          <div class="contact_box flex-box flex-between">
            <div class="flex-box flex-grow-1">
              <div class="title fs18">联系人</div>
              <input class="input fs16 m-input" type="text" placeholder="请输入打版联系人" />
            </div>
            <div class="flex-box flex-grow-1 flex-end">
              <div class="title fs18">联系方式</div>
              <input class="input fs16 m-input" type="text" placeholder="请输入联系人手机号" />
            </div>
          </div>
        </div>
        <div class="guidance2 flex-box">
          <div class="flex-box flex-grow-1">
            <i class="icon_check mr25"></i>
            <div class="fs18 col04">已阅读并同意</div>
            <div class="fs18 zbule1 fwb">《****拼团条款》</div>
          </div>
          <div class="btn_sub">确认报名</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Pay",
  setup() {},
  data() {
    return {
      isShowAll: false,
    };
  },
  created() {},
  methods: {
    showAllAddr() {
      this.isShowAll = !this.isShowAll;
    },
  },
};
</script>
<style lang="less" scoped>
.pay_header {
  padding: 0 260px;
  height: 150px;
  background: #f9f9f9;
  .icon_logo {
    display: block;
    width: 170px;
  }
  .line {
    margin: 0 60px;
    width: 1px;
    height: 100px;
    background: rgba(98, 134, 171, 0.4);
  }
  .name {
    font-weight: bold;
    color: #040404;
    line-height: 40px;
    letter-spacing: 1px;
    text-align: left;
    font-style: normal;
  }
}
.pay_wrap {
  padding: 25px 260px 190px;
  .icon_check {
    display: block;
    width: 20px;
    height: 20px;
    background-image: url(@/assets/static/icon/z_icon_check1.png);
    background-size: 20px;
    background-repeat: no-repeat;
  }
  .icon_checkon {
    display: block;
    width: 20px;
    height: 20px;
    background-image: url(@/assets/static/icon/z_icon_checkon1.png);
    background-size: 20px;
    background-repeat: no-repeat;
  }

  .comfirm {
    margin-right: 12px;
    font-weight: bold;
    font-size: 24px;
    color: #040404;
    line-height: 33px;
    text-align: left;
    font-style: normal;
  }
  .address_box {
    padding: 42px 44px 26px;
    margin: 0 0 14px;
    width: 1400px;
    background: #ffffff;
    .address_list {
      margin: 0 0 10px;
      max-height: 130px;
      overflow-y: hidden;
      .address_item {
        padding: 24px 24px 10px;
        margin: 0 20px 20px 0;
        width: 646px;
        height: 128px;
        border-radius: 8px;
        border: 2px solid rgba(98, 134, 171, 0.2);
        cursor: pointer;
        .icon_addr {
          margin-right: 20px;
          display: block;
          width: 24px;
          height: 28px;
          background-image: url(@/assets/static/icon/z_icon_addr1.png);
          background-size: 24px 28px;
          background-repeat: no-repeat;
        }
      }
      .address_item.active {
        border: 2px solid #3d7efe;
        .icon_addr {
          background-image: url(@/assets/static/icon/z_icon_addr2.png);
        }
      }
      .address_item:nth-of-type(2n) {
        margin: 0 0 20px;
      }
    }
    .address_list.show {
      max-height: unset;
    }
    .more {
      .icon {
        margin-left: 10px;
        display: block;
        width: 14px;
        height: 14px;
      }
    }
  }
  .goods_wrap {
    padding: 42px 44px 44px;
    margin: 0 0 14px;
    width: 1400px;
    background: #ffffff;
    .goods_title {
      height: 68px;
      background: #fafcff;
      div {
        color: #040404;
      }
      .gt1 {
        margin-left: 326px;
      }
      .gt2 {
        margin-left: 175px;
      }
      .gt3 {
        margin-left: 105px;
      }
      .gt4 {
        margin-left: 115px;
      }
      .gt5 {
        margin-left: 94px;
      }
    }
    .goods_item {
      padding: 24px 12px 24px 44px;
      border-bottom: 1px solid rgba(98, 134, 171, 0.4);
      .img1 {
        margin-right: 26px;
        display: block;
        width: 144px;
        height: 144px;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid rgba(98, 134, 171, 0.2);
      }
      .name {
        width: 258px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #040404;
        line-height: 25px;
        text-align: left;
        font-style: normal;
        .label {
          padding: 0 7px;
          width: 43px;
          height: 20px;
          background: linear-gradient(117deg, #3d6cfe 0%, #4ac3fc 100%);
          border-radius: 4px;
          border-image: linear-gradient(196deg, rgba(255, 255, 255, 1), rgba(18, 117, 255, 0)) 1 1;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 20px;
          letter-spacing: 1px;
          text-align: center;
          font-style: normal;
        }
      }
      .spec {
        margin: 0 5px;
        width: 158px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #040404;
        line-height: 25px;
        text-align: center;
        font-style: normal;
      }
      .danjia {
        width: 138px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #909090;
        line-height: 25px;
        text-align: center;
        font-style: normal;
      }
      .youhui {
        padding: 0 18px;
        margin: 0 30px;
        width: 140px;
        height: 40px;
        border-radius: 8px;
        border: 1px solid rgba(98, 134, 171, 0.4);
        cursor: pointer;
        .fs18 {
          color: #3d7efe;
        }
        .icon_down {
          display: block;
          width: 11px;
          height: 11px;
          background-image: url(@/assets/static/icon/z_icon_down2.png);
          background-size: 11px;
          background-repeat: no-repeat;
        }
      }
      .num {
        width: 142px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #272727;
        line-height: 16px;
        text-align: center;
        font-style: normal;
      }
      .total {
        width: 172px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #eb3f25;
        line-height: 25px;
        text-align: center;
      }
    }
  }

  .pay_box {
    margin: 0 0 14px;
    padding: 44px;
    background: #ffffff;

    .pay_item {
      margin-right: 20px;
      padding: 0 44px;
      width: 424px;
      height: 192px;
      border-radius: 8px;
      border: 2px solid rgba(98, 134, 171, 0.2);
      cursor: pointer;
      .icon_pay1 {
        margin: 0 24px 0 47px;
        display: block;
        width: 61px;
        height: 54px;
      }
      .icon_pay2 {
        margin: 0 24px 0 47px;
        display: block;
        width: 59px;
        height: 48px;
      }
    }
    .pay_item.active {
      border: 2px solid #3d7efe;
    }
    .btn_sub {
      margin: 0 0 0 auto;
      width: 108px;
      height: 44px;
      background: #1275ff;
      border-radius: 6px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      line-height: 44px;
      text-align: center;
      font-style: normal;
      cursor: pointer;
    }
  }
  .guidance_box {
    background-color: #fff;
    .guidance1 {
      padding: 40px 44px;
      .option + .option {
        margin-left: 343px;
      }

      .contact_box {
        margin: 24px 0 0;
        padding: 0 44px;
        height: 138px;
        background: #fbfcfd;
        .title {
          position: relative;
          margin-right: 14px;
          padding-left: 20px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #040404;
          line-height: 25px;
          text-align: left;
          font-style: normal;
        }
        .title::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 12px;
          height: 12px;
          background: #eb3f25;
          border-radius: 50%;
        }
        .input {
          padding: 0 24px;
          width: 480px;
          height: 50px;
          background: #ffffff;
          border-radius: 8px;
          border: 2px solid rgba(98, 134, 171, 0.2);
          line-height: 22px;
          text-align: left;
        }
      }
    }
    .guidance2 {
      padding: 14px 44px 25px 44px;
      border-top: 1px solid rgba(98, 134, 171, 0.4);
      .btn_sub {
        width: 108px;
        height: 44px;
        background: #1275ff;
        border-radius: 6px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 20px;
        color: #ffffff;
        line-height: 44px;
        text-align: center;
        font-style: normal;
        cursor: pointer;
      }
    }
  }
}
</style>
